import React, { useState } from 'react'
import { ToggleButton, ToggleButtonGroup, RadioGroup, FormControlLabel, Radio } from '@mui/material'

const Toggle = (props) => {
    const [response, setResponse] = useState(props.question.Responses[0].Response)


    const changeAnswer = (e, v) => {
        if (v) {

            props.saveAnswer(v, props.QuestionId)
            setResponse(v)
        } else {
            props.saveAnswer('-1', props.QuestionId)
            setResponse('-1')
        }
    }
    if (props) {
        let answerArray = [...props.question.Answers]
        return (

            <ToggleButtonGroup
                color="primary"
                exclusive
                orientation={props.question.QuestionSetHasContent ? "vertical" : "horizontal"}
                row={!props.question.QuestionSetHasContent}
                value={response}
                onChange={changeAnswer}
                sx={{ width: "100%" }}>
                {answerArray.sort((a, b) => (parseInt(a.AnswerSequenceInQuestion) - parseInt(b.AnswerSequenceInQuestion)))
                    .map(answer =>
                        <ToggleButton value={answer.AnswerId}
                            sx={{ fontSize: { xs: props.question.Answers.length > 3 && !props.question.QuestionSetHasContent ? (14-(props.question.Answers.length - 3) + "px") : '', s: '' } }}>
                            {answer.AnswerStandardContent}</ToggleButton>
                    )}
            </ToggleButtonGroup>
        )
    } else return <p></p>
}

export default Toggle;

/**
 * import React, { Component } from 'react'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Radio from '@material-ui/core/Radio'

const Toggle = (props) => {
        if(props){
            let answer = this.props.answer;
            return(
                //<Radio>Answer</Radio>
                <FormControlLabel style={{paddingBottom:'8px'}} value={answer.AnswerId} control={<Radio />} label={answer.AnswerStandardContent} />
            )
        } else return <p>nope</p> 
}

export default Toggle;



if (!props.question.QuestionSetHasContent) 
        return(
            <RadioGroup row={!props.question.QuestionSetHasContent} value={response} onChange={changeAnswer} sx={{flexDirection: {sx:'column', s: 'row'}}}>
                        {answerArray.sort((a, b) => (parseInt(a.AnswerSequenceInQuestion) - parseInt(b.AnswerSequenceInQuestion)))
                        .map(answer => 
                            <FormControlLabel style={{paddingBottom:'8px'}} value={answer.AnswerId} control={<Radio />} label={answer.AnswerStandardContent} />
                        )}
            </RadioGroup>
            )
        else
 */